<template>
  <nav class="material-page-navigation inline-flex items-center gap-3" :aria-label="$t('default.material_bank.title')">
    <template v-for="item in items" :key="item.key">
      <router-link
        v-if="item.target"
        :to="'/material/' + item.target.path"
        :title="item.target.title"
        :aria-label="item.target.title"
        class="material-page-navigation__item text-green hover:text-green-dark"
        :data-nav="item.key"
      >
        <font-awesome-icon :icon="item.icon" />
      </router-link>
      <span
        v-else
        :aria-label="$t(item.label)"
        aria-disabled="true"
        class="material-page-navigation__item material-page-navigation__item--disabled text-gray-300 cursor-default"
        :data-nav="item.key"
      >
        <font-awesome-icon :icon="item.icon" />
      </span>
    </template>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
  navigation: {
    type: Object,
    default: undefined,
  },
})

const items = computed(() => {
  const nav = props.navigation || {}
  return [
    { key: 'previous', icon: 'fa-solid fa-arrow-left', label: 'default.material_bank.nav_previous', target: nav.previous || null },
    { key: 'up', icon: 'fa-solid fa-arrow-up', label: 'default.material_bank.nav_up', target: nav.up || null },
    { key: 'next', icon: 'fa-solid fa-arrow-right', label: 'default.material_bank.nav_next', target: nav.next || null },
  ]
})
</script>

<style scoped>
.material-page-navigation__item {
  padding: 0 0.25rem;
}
</style>
